// Job item  ************************************************************************************
// pathname: /v1/job-operation/{jobSlug}/job-item
// ************************************************************************************************
import { useSwrApi } from 'src/hooks/useSwrApi';

interface UseSwrJobItemProps {
  jobSlug: string;
  locale?: string;
  serverSideData?: ApiSchema<'JobItem'>;
  shouldFetch?: boolean;
}
/**
 * @description SWR: fetch job detail.
 * @param jobSlug - string. The job slug.
 * @param locale - string. The locale to use for the request.
 * @param serverSideData - ApiSchema<'JobItem'>. Server-side data to use for the initial render. Optional.
 * @param shouldFetch - boolean. If true, the hook will fetch data from the API. If false, it will use the server-side data only.
 *
 * @example
 * const { data: jobItem, isLoading: isLoadingJobItem } = useSwrJobItem({jobSlug: 'slug-123', locale: 'ro'});
 */
export const useSwrJobItem = (props: UseSwrJobItemProps) => {
  const {
    jobSlug, locale, serverSideData, shouldFetch,
  } = props;

  // SWR: fetch data
  // ********************************************
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiSchema<'JobItem'>>({
    url: `/v1/job-operation/${jobSlug}/job-item`,
    locale,
    serverSideData,
    shouldFetch,
    apiOptions: {
      dedupingInterval: 1000 * 10, // 10 seconds
    },
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
